import { render, staticRenderFns } from "./addAgeGroup.vue?vue&type=template&id=70c01d44&"
import script from "./addAgeGroup.vue?vue&type=script&lang=js&"
export * from "./addAgeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c01d44')) {
      api.createRecord('70c01d44', component.options)
    } else {
      api.reload('70c01d44', component.options)
    }
    module.hot.accept("./addAgeGroup.vue?vue&type=template&id=70c01d44&", function () {
      api.rerender('70c01d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuremanagement/ageGroupList/component/addAgeGroup.vue"
export default component.exports